import { render } from "./OrderInfo.vue?vue&type=template&id=36cb6add"
import script from "./OrderInfo.vue?vue&type=script&lang=js"
export * from "./OrderInfo.vue?vue&type=script&lang=js"

import "./OrderInfo.vue?vue&type=style&index=0&id=36cb6add&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__